/* lust-us-final2706v2.js — consolidated, single checkout handler
   Reads image URLs from window.lustF2706Config injected by section
   2026-06-28
*/
(function () {
  'use strict';

  var ROOT = '.lust-final2706-single';
  var root = document.querySelector(ROOT);
  if (!root) return;

  var cfg = window.lustF2706Config || {};

  /* ── 1. HERO CAROUSEL ── */
  (function () {
    var img = root.querySelector('#heroImg');
    if (!img) return;
    var slides = cfg.heroSlides || [];
    var imgs = slides.map(function (slide) { return slide.image; });
    if (!imgs.length) return;
    var infoEy = root.querySelector('#heroInfoEy');
    var infoTitle = root.querySelector('#heroInfoTitle');
    var infoCopy = root.querySelector('#heroInfoCopy');

    var dotWrap = root.querySelector('.carousel-dots');
    var dots;
    if (dotWrap) {
      dotWrap.innerHTML = imgs.map(function (_, i) {
        return '<span' + (i === 0 ? ' class="active"' : '') + '></span>';
      }).join('');
      dots = root.querySelectorAll('.carousel-dots span');
    } else {
      dots = [];
    }

    imgs.forEach(function (src) { var im = new Image(); im.src = src; });

    var cur = 0, busy = false;
    img.style.transition = 'opacity .22s ease';

    function setDot(i) {
      [].forEach.call(dots, function (d, idx) { d.classList.toggle('active', idx === i); });
    }

    function setSlideCopy(i) {
      var slide = slides[i] || {};
      if (infoEy) infoEy.textContent = slide.eyebrow || '';
      if (infoTitle) infoTitle.textContent = slide.title || '';
      if (infoCopy) infoCopy.textContent = slide.copy || '';
      if (slide.alt) img.alt = slide.alt;
    }

    function go(dir) {
      if (busy) return;
      busy = true;
      cur = (cur + dir + imgs.length) % imgs.length;
      setDot(cur);
      setSlideCopy(cur);
      img.style.opacity = '0';
      setTimeout(function () {
        img.onload = function () {
          img.style.opacity = '1';
          setTimeout(function () { busy = false; }, 230);
          img.onload = null;
        };
        img.src = imgs[cur];
        if (img.complete) { img.style.opacity = '1'; setTimeout(function () { busy = false; }, 230); }
      }, 90);
    }

    var prev = root.querySelector('.cs-prev');
    var nxt = root.querySelector('.cs-next');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (nxt) nxt.addEventListener('click', function () { go(1); });
    setDot(0);
    setSlideCopy(0);
  }());

  /* ── 2. PACK SELECTOR + PRICE DISPLAY ── */
  var opts = [].slice.call(root.querySelectorAll('.pack-opt'));
  var qtyInput = root.querySelector('#lustFinal2706Qty');
  var priceNow = root.querySelector('#priceNow');
  var priceWas = root.querySelector('#priceWas');
  var perNote = root.querySelector('#perNote');
  var shipBadge = root.querySelector('#shipBadge');
  var stickyLbl = root.querySelector('#stickyLabel');
  var stickyMeta = root.querySelector('#stickyMeta');
  var stickyOpts = [].slice.call(root.querySelectorAll('.sticky-pack'));
  var altCta = root.querySelector('#altCta');
  var packBadge = root.querySelector('.pack-opt .pop');

  function qtyFrom(opt) {
    var m = (opt.dataset.href || '').match(/:(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function stickyPackCopy(opt) {
    var qty = qtyFrom(opt);
    return {
      title: qty + (qty === 1 ? ' BOX' : ' BOXES'),
      meta: (qty * 3) + ' couple servings · ' + (opt.dataset.price || '')
    };
  }

  function renderPackBadge(opt, qty) {
    if (!packBadge || !opt) return;
    var label = qty === 2 ? 'MOST LOVED' : (qty === 3 ? 'BEST VALUE' : '');
    opt.appendChild(packBadge);
    packBadge.textContent = label;
    packBadge.hidden = !label;
    packBadge.setAttribute('aria-hidden', label ? 'false' : 'true');
  }

  function renderPack(opt) {
    if (!opt) return;
    opts.forEach(function (o) { o.classList.remove('sel'); o.setAttribute('aria-checked', 'false'); });
    opt.classList.add('sel');
    opt.setAttribute('aria-checked', 'true');
    var qty = qtyFrom(opt);
    if (qtyInput) qtyInput.value = qty;
    if (priceNow) priceNow.textContent = opt.dataset.price || '';
    if (priceWas) priceWas.textContent = opt.dataset.was || '';
    if (perNote) perNote.textContent = opt.dataset.per || '';
    if (shipBadge) shipBadge.textContent = opt.dataset.badge || '';
    var stickyCopy = stickyPackCopy(opt);
    if (stickyLbl) stickyLbl.textContent = stickyCopy.title;
    if (stickyMeta) stickyMeta.textContent = stickyCopy.meta;
    renderPackBadge(opt, qty);
    stickyOpts.forEach(function (button) {
      var selected = parseInt(button.dataset.qty, 10) === qty;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  }

  opts.forEach(function (opt) {
    opt.setAttribute('role', 'radio');
    opt.tabIndex = 0;
    opt.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); renderPack(opt); });
    opt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); renderPack(opt); }
    });
  });

  stickyOpts.forEach(function (button) {
    button.addEventListener('click', function () {
      var qty = parseInt(button.dataset.qty, 10);
      var match = opts.filter(function (opt) { return qtyFrom(opt) === qty; })[0];
      if (match) renderPack(match);
    });
  });

  if (altCta) {
    altCta.addEventListener('click', function (e) {
      e.preventDefault();
      if (opts[0]) renderPack(opts[0]);
    });
  }

  renderPack(root.querySelector('.pack-opt.sel') || opts[1] || opts[0]);

  /* ── 3. CHECKOUT HANDLER — single, BFC-safe ── */
  function selectedQty() {
    var sel = root.querySelector('.pack-opt.sel');
    if (sel) {
      var m = (sel.dataset.href || '').match(/:(\d+)/);
      if (m) return parseInt(m[1], 10) || 1;
    }
    return parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
  }

  function checkout(btn) {
    var variantInput = root.querySelector('#lustFinal2706ProductForm input[name="id"]');
    var id = variantInput && variantInput.value;
    var qty = selectedQty();
    if (qtyInput) qtyInput.value = qty;
    btn.textContent = 'CHECKING OUT…';
    if (!id) { window.location.assign('/checkout'); return; }
    window.location.assign('/cart/clear?return_to=' + encodeURIComponent('/cart/' + id + ':' + qty + '?checkout'));
  }

  function armCheckout() {
    ['#mainCta', '#stickyCta'].forEach(function (sel) {
      var btn = root.querySelector(sel);
      if (!btn || btn.dataset.checkoutArmed === '1') return;
      btn.dataset.checkoutArmed = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        checkout(btn);
      }, true);
    });
  }

  armCheckout();

  /* Re-arm after bfcache restore so button isn't stuck in loading state */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      ['#mainCta', '#stickyCta'].forEach(function (sel) {
        var btn = root.querySelector(sel);
        if (btn) {
          btn.textContent = 'BUY NOW';
          delete btn.dataset.checkoutArmed;
        }
      });
      armCheckout();
    }
  });

  /* ── 4. NATIVE SMOOTH SCROLL TO BUY PANEL ── */
  var buyPanel = root.querySelector('#buy-panel');
  function scrollToBuyPanel() {
    if (!buyPanel) return;
    buyPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (buyPanel) {
    root.querySelectorAll('a[href="#buy-panel"], a[href="#buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToBuyPanel();
      }, true);
    });
  }

  /* What's in it → ingredient headline. Account for whichever storefront header
     is actually fixed/sticky so the full headline lands inside the viewport. */
  var ingredientSection = root.querySelector('#every-ingredient');
  var ingredientLink = root.querySelector('.nh-inline-link[href="#every-ingredient"]');
  function visibleHeaderOffset() {
    var offset = 16;
    document.querySelectorAll('header, .header, .shopify-section-header-sticky, [data-sticky-header]').forEach(function (el) {
      if (root.contains(el)) return;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      var rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0 && rect.top <= 1) offset = Math.max(offset, Math.ceil(rect.bottom) + 16);
    });
    return offset;
  }
  if (ingredientSection && ingredientLink) {
    ingredientLink.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var top = ingredientSection.getBoundingClientRect().top + window.pageYOffset - visibleHeaderOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#every-ingredient');
    }, true);
  }

  /* Keep the fixed bar from covering the in-page checkout/guarantee. */
  var stickyWrap = root.querySelector('.sticky');
  if (stickyWrap && 'IntersectionObserver' in window) {
    var stickyGuard = new IntersectionObserver(function (entries) {
      var checkoutAreaVisible = entries.some(function (entry) { return entry.isIntersecting; });
      stickyWrap.classList.toggle('is-hidden', checkoutAreaVisible);
      stickyWrap.setAttribute('aria-hidden', checkoutAreaVisible ? 'true' : 'false');
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    stickyGuard.observe(buyPanel);
  }

  /* ── 5. BUY PANEL ACCORDIONS — one open at a time ── */
  root.querySelectorAll('.bp-accordions details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      root.querySelectorAll('.bp-accordions details').forEach(function (other) {
        if (other !== d) other.removeAttribute('open');
      });
    });
  });

  /* ── 6. COUNT-UP STATS ── */
  var statNums = [].slice.call(root.querySelectorAll('.count-up'));
  var statsFired = false;

  function animateStats() {
    if (statsFired) return;
    statsFired = true;
    statNums.forEach(function (el) {
      var target = parseFloat(el.dataset.target || '0');
      var suffix = el.dataset.suffix || '';
      var dec = parseInt(el.dataset.decimal || '0', 10);
      var start = null, dur = 1300;
      function step(ts) {
        start = start || ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var v = target * eased;
        el.textContent = (dec ? v.toFixed(dec) : Math.floor(v)) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (dec ? target.toFixed(dec) : target) + suffix;
      }
      requestAnimationFrame(step);
    });
  }

  var statsGrid = root.querySelector('.nums');
  function checkStats() {
    if (!statsGrid || statsFired) return;
    var r = statsGrid.getBoundingClientRect();
    if (r.top < window.innerHeight * .68 && r.bottom > 0) animateStats();
  }
  window.addEventListener('scroll', checkStats, { passive: true });
  window.addEventListener('resize', checkStats);
  setTimeout(checkStats, 250);

  /* ── 7. TIMELINE CARDS — static raised cards, no scroll glow work ── */
  [].slice.call(root.querySelectorAll('.drum-item')).forEach(function (card) { card.classList.add('visible'); });



  /* ── 7b. TIME PILL GRADIENT PROGRESS — only 0/15/30/2->4 tags ── */
  (function () {
    var items = [].slice.call(root.querySelectorAll('.drum-item'));
    if (!items.length) return;
    var ticking = false;
    function updateTimePills() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;
      items.forEach(function (item) {
        var badge = item.querySelector('.di-time-badge');
        if (!badge) return;
        var r = item.getBoundingClientRect();
        var start = vh * 0.88;
        var end = vh * 0.28;
        var p = (start - r.top) / (start - end);
        p = Math.max(0, Math.min(1, p));
        badge.style.setProperty('--time-progress', Math.round(p * 100) + '%');
      });
    }
    function requestUpdate() { if (!ticking) { ticking = true; requestAnimationFrame(updateTimePills); } }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    setTimeout(updateTimePills, 120);
  }());

  /* ── 8. PRESS STAT REVEAL ── */
  [].slice.call(root.querySelectorAll('.press-stat-row')).forEach(function (row) {
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        var v = card.querySelector('video');
        var b = card.querySelector('.f2706-sound');
        if (v) { loadVideo(v); stopAndMute(v, b); }
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { row.classList.add('visible'); io.disconnect(); }
    }, { threshold: 0.45, rootMargin: '0px 0px -60px 0px' });
    io.observe(row);
  });

  /* ── 9. REVIEW CARDS — infinite auto-scroll ── */
  (function () {
    var el = root.querySelector('.rev-scroll');
    if (!el || el.dataset.mobileAutoplay) return;
    el.dataset.mobileAutoplay = '1';

    var origCards = [].slice.call(el.querySelectorAll('.rv'));
    origCards.forEach(function (c) { el.appendChild(c.cloneNode(true)); });

    var paused = false;
    el.style.scrollSnapType = 'none';
    el.scrollLeft = 0;

    function tick() {
      if (!paused) {
        el.scrollLeft += 0.7;
        var half = el.scrollWidth / 2;
        if (el.scrollLeft >= half) el.scrollLeft -= half;
      }
      requestAnimationFrame(tick);
    }

    el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    el.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 900); });
    el.addEventListener('mousedown', function () { paused = true; });
    el.addEventListener('mouseup', function () { paused = false; });
    el.addEventListener('mouseleave', function () { paused = false; });

    requestAnimationFrame(tick);
  }());

  /* ── 10. VIDEO — inline-only viewport autoplay; sound is best effort ── */
  (function () {
    var cards = [].slice.call(root.querySelectorAll('.f2706-video-card'));
    if (!cards.length) return;

    function loadVideo(v) {
      if (v && !v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
    }

    function playWithSound(v, btn) {
      if (!v) return;
      loadVideo(v);
      /* Explicit properties prevent iOS/WebKit from promoting playback fullscreen. */
      v.playsInline = true;
      v.disablePictureInPicture = true;
      v.disableRemotePlayback = true;
      v.muted = false;
      v.volume = 1;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          /* Unmuted autoplay commonly needs a gesture: stay inline and continue muted. */
          v.muted = true;
          var fallback = v.play();
          if (fallback && fallback.catch) fallback.catch(function () {});
          updateSoundButton(btn, false, true);
        });
      }
      updateSoundButton(btn, true, false);
    }

    function updateSoundButton(btn, soundOn, blocked) {
      if (!btn) return;
      btn.classList.toggle('on', !!soundOn);
      btn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      btn.setAttribute('aria-label', soundOn ? 'Turn sound off' : (blocked ? 'Autoplay is muted. Tap to turn sound on' : 'Turn sound on'));
    }

    function stopAndMute(v, btn) {
      if (!v) return;
      v.pause();
      v.muted = true;
      updateSoundButton(btn, false, false);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var card = e.target;
        var v = card.querySelector('video');
        var b = card.querySelector('.f2706-sound');
        if (!v) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          playWithSound(v, b);
        } else {
          stopAndMute(v, b);
        }
      });
    }, { threshold: [0, 0.5, 0.75, 1] });

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      var b = card.querySelector('.f2706-sound');
      if (!v) return;
      v.muted = true;
      v.playsInline = true;
      v.disablePictureInPicture = true;
      v.disableRemotePlayback = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('controlslist', 'nofullscreen noremoteplayback nodownload');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('disableremoteplayback', '');
      if (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          loadVideo(v);
          v.muted = !v.muted;
          updateSoundButton(b, !v.muted, false);
          var tappedPlay = v.play();
          if (tappedPlay && tappedPlay.catch) tappedPlay.catch(function () {});
        });
      }
      io.observe(card);
    });
  }());

  /* Keep the 2207 timeline in the exact visual order used by the live
     homepage's “How the Ritual Unfolds” section. */
  (function () {
    var ritualImages = [
      '/cdn/shop/t/27/assets/lust-home-ritual-0min.jpg',
      '/cdn/shop/t/27/assets/lust-home-ritual-4hours.jpg',
      '/cdn/shop/t/27/assets/lust-home-ritual-15min.jpg',
      '/cdn/shop/t/27/assets/lust-home-ritual-30min.jpg'
    ];
    var timelineImages = [].slice.call(root.querySelectorAll('#feelDrum .drum-item .di-img-wrap img'));
    timelineImages.slice(0, ritualImages.length).forEach(function (img, index) {
      img.src = ritualImages[index];
      img.removeAttribute('srcset');
    });
  }());

  /* The inline hero alignment runs once before this deferred bundle. Lock that
     settled position so delayed font/load callbacks from cached markup cannot
     nudge “mood.” sideways after its entrance animation. */
  (function () {
    var mood = root.querySelector('.hero-text .mega-mood');
    if (!mood || document.getElementById('lust-mood-position-lock')) return;
    var settledMargin = window.getComputedStyle(mood).marginLeft;
    var lock = document.createElement('style');
    lock.id = 'lust-mood-position-lock';
    lock.textContent = '.lust-final2706-single .hero-text .mega-mood{margin-left:' +
      settledMargin + '!important;}';
    document.head.appendChild(lock);
  }());

}());
